import React from 'react';
import { Alert, Col, Row, Space } from 'antd';
import type { BqInsightsResponse } from '@/types';
import { BqKpiTiles } from './BqKpiTiles';
import { BqInsightsList } from './BqInsightsList';
import { BqTrends } from './BqTrends';
import { BqFtueFunnel } from './BqFtueFunnel';
import { BqSegmentsTable } from './BqSegmentsTable';
import { BqModelsPanel } from './BqModelsPanel';
import { BqRetentionTable } from './BqRetentionTable';
import { isFiltered } from './bqMath';

/** The whole BigQuery Insights page below the header; pure render of one response. */
export const BqInsightsBoard: React.FC<{ data: BqInsightsResponse }> = ({ data }) => {
  const filtered = isFiltered(data);
  return (
    <Space direction="vertical" size={12} style={{ width: '100%' }}>
      {data.unavailable.length > 0 && (
        <Alert
          type="warning"
          showIcon
          message={`Not available right now: ${data.unavailable.join(', ')}`}
          description="BigQuery did not answer these sections (not configured, over today's query budget, or an error). The rest of the page is current; try again in a few minutes."
        />
      )}
      <div data-section="kpis">
        <BqKpiTiles kpis={data.kpis} dataThrough={data.dataThrough} />
      </div>
      <div data-section="insights">
        <BqInsightsList insights={data.insights} wholeGame={filtered} />
      </div>
      <div data-section="trends">
        <BqTrends kpis={data.kpis} />
      </div>
      <div data-section="retention">
        <BqRetentionTable retention={data.retention} />
      </div>
      <div data-section="models">
        <BqModelsPanel
          models={data.models}
          scores={data.scores}
          drivers={data.drivers}
          wholeGame={filtered}
        />
      </div>
      <Row gutter={[12, 12]}>
        <Col xs={24} xl={10} data-section="ftue">
          <BqFtueFunnel ftue={data.ftue} dayZero={filtered} />
        </Col>
        <Col xs={24} xl={14} data-section="segments">
          <BqSegmentsTable segments={data.segments} wholeGame={filtered} />
        </Col>
      </Row>
    </Space>
  );
};
